export enum RoadwayClassifications {
  parkingLotLight = "Parking Lot - Light Duty",
  parkingLotHeavy = "Parking Lot - Heavy Duty",
  residential = "Residential/Collector",
  local = "Local",
  arterial = "Arterials/Highway",
  interstate = "Interstate"
}
